<template>
  <div v-if='tableData && tableData.length>0' style='margin-bottom: 5px'>
    <div v-for='( row,$index) in tableData' :key='$index' style='position: relative' class='plc-item-panel'>
      <div>
        <div style='margin: 5px;text-align: center' v-if='showEditBtn'>
          <el-link type='primary' @click='jumpToPlcItemDetail(row)'>查看提报详情</el-link>
        </div>
        <div class='org-name' :title='`${row.id}`'>{{ row.org_name }}</div>
        <div class='circle-delete' @click='delPlcItem(row,$index)'
             v-if="userPermissions.indexOf('plc_delete')>-1 && showEditBtn"></div>
        <!--        基本信息-->
        <div class='theme-border'
             style='display: flex; flex-direction: row;justify-content: flex-start;align-items: center;gap: 5px;padding: 10px'>
          <div
              style='width: 98%;display: flex; flex-direction: row;justify-content: flex-start;align-items: flex-start;gap: 5px'>
            <div style='width: clamp(500px, 40%, 680px); padding: 10px' class='theme-border'>
              <!--                    基本信息-->
              <PanelKolInfo :data='row' :index='$index' style='height: 100%;margin-bottom: 8px;'
                            @editIntro='editVal' :platform-type='setting.type' :setting='setting'/>

              <!--              <PanelPlatformInfo :data='row' :setting='setting' style='height: 100%;margin-bottom: 8px;'/>-->
            </div>
            <div style='width: clamp(800px, 60%, 1200px); padding: 10px' class='theme-border'>
              <FormView :form-render-struct='formRenderData'
                        :form-data='row' :setting='setting'/>
            </div>
          </div>

          <div class='edit-btn' v-if='showEditBtn'>
            <div v-if="userPermissions.indexOf('plc_adjust')>-1" class='theme-border' style='padding: 10px'>
              <el-link type='primary'
                       @click='editAPlcDetail(row,$index,"base")'
                       v-if="userPermissions.indexOf('plc_adjust')>-1" class='vertical-lr'>
                <i class='el-icon-edit-outline '></i>
                基本信息
              </el-link>
            </div>
          </div>
        </div>


        <!--        报价信息-->
        <div class='theme-border price-info'
             style='display: flex;justify-content: flex-start;align-items: center;gap: 5px;margin-top: 10px;padding: 10px;position: relative;'>
          <div class='status-alias'>{{ row.status_alias }}</div>
          <div class='apply-status' v-if='row.apply_status===2'>申请改价,待审核</div>

          <div class='price-show theme-border' style='width: 96%;min-height: 200px'>
            <div v-if="row.status===2">
              <PriceStructView :quote-obj='row["real_quote"]' :platform-type='setting.type'
                               v-if='setting&& setting.type' style='width: 98%;margin: auto'/>
            </div>
            <div v-else>尚未定价</div>
          </div>
          <div v-if='showEditBtn'
               style='display: flex;flex-direction: column;justify-content: space-evenly;gap: 5px;height: 100%;'>
            <div class='theme-border' style='padding: 10px;'
                 v-if="userPermissions.indexOf('plc_save_quote')>-1 && row.status==1">
              <el-link :underline='false' type='warning' @click='surePrice(row,$index)'
                       class='edit-price vertical-lr'>
                <i class='el-icon-edit-outline'></i>
                定价
              </el-link>
            </div>
            <div class='theme-border' style='padding: 10px;' v-if='row.apply_status===2'>
              <el-link type='text' @click='jumpToPlcItemDetail(row)'
                       :disabled="userPermissions.indexOf('plc_check')===-1"
                       style='color: #FFBA00;margin: 0;' class=' vertical-lr'>
                <span class='el-icon-warning-outline'></span>审核
              </el-link>

            </div>
            <div class='theme-border' style='padding: 10px;'
                 v-if='userPermissions.indexOf("plc_edit_price")>-1&& row.status==2'>
              <el-link title='申请改价，改的是定价还是之前的预估价？'
                       :underline='false' type='primary'
                       @click='editPrice(row,$index,"price")'
                       class='edit-price vertical-lr' style='margin: 0;'>
                <i class='el-icon-edit-outline'></i>申请改价
              </el-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PanelKolInfo from './PanelKolInfo.vue'
import PriceStructView from '@/pages/plc/compoents/PriceStructView.vue'
import PanelBsCase from '@/pages/plc/compoents/PanelBsCase.vue'
import PanelPlatformInfo from '@/pages/plc/compoents/PanelPlatformInfo.vue'
import {mapGetters} from 'vuex'
import FormView from './FormView.vue'
import plcMap from '@/json/plc.json'

export default {
  name: 'PlcRecords',
  components: {FormView, PanelPlatformInfo, PanelBsCase, PriceStructView, PanelKolInfo},
  props: {
    setting: {
      type: Object,
      default() {
        return {}
      }
    },
    tableData: {
      type: Array,
      default() {
        return []
      }
    },
    isShowAll: {
      type: Boolean,
      default() {
        return false
      }
    },
    showEditBtn: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    ...mapGetters(['userPermissions']),
    formRenderData() {
      const cols = []

      plcMap.common_cols.forEach((f) => {
        //&& this.fieldRange[f.field]
        if (f && this.fieldRange.indexOf(f.field) > -1) {
          cols.push(f)
        }
      })
      return cols
    },
    //可查看的字段范围：不同平台配置不同的字段显示
    fieldRange() {
      if (this.setting) {
        const common_fields = this.setting.common_fields || []
        return [...common_fields]
      } else {
        return []
      }

    }
  },
  data() {
    return {}
  },
  methods: {
    jumpToPlcItemDetail(row) {
      this.$router.push({
        name: 'plc_item', params: {id: row.id}
      })
    },
    //修改刊例提报信息
    editVal(row, field, index) {
      this.$emit('editVal', row, field, index)
    },
    surePrice(row) {
      const id = row.id
      //一个刊例定价页面-只打开一个窗口
      const windowTarget = `plc_do_priced_${id}`
      // const windowTarget = "_blank"
      const windowFeatures = 'left=50,top=50,width=1200,height=900'
      // 浏览器打开新窗口，若是钉钉微应用，则路由跳转 id: row.id,
      this.$utils.safeOpenWindow(this, {
        name: 'plc_do_priced',
        query: {
          id: row.id,
          journal_id: row.journal_id,
          pm_id: row.pm_id,
          artist_id: row.artist_id,
          platform_code: row.platform_code
        }
      }, windowTarget, windowFeatures)

      // const routeURL = this.$router.resolve({
      //   name: 'plc_do_priced',
      //   query: {pm_id: row.pm_id, artist_id: row.artist_id, platform_code: row.platform_code}
      // }).href
      //
      // window.open(routeURL, '_blank')
    },
    editRow(row, index, mod) {
      this.$emit('editRow', row, index, mod)
    },
    editPrice(row, index, mod) {
      this.$emit('editPrice', row, index, mod)
    },
    editAPlcDetail(row, index, mod) {
      this.$emit('editAPlcDetail', row, index, mod)
    },
    delPlcItem(row, index) {
      this.$emit('delPlcItem', row, index)
    }

  }
}
</script>

<style scoped>
.plc-item-panel {
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #f2f2f2;
  border-radius: 8px;
}

.plc-item-panel:hover {
  border: 1px dashed var(--primary);
  padding: 12px;
}

.org-name {
  position: absolute;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  line-height: 40px;
  text-align: center;
  border: 1px solid var(--primary);
  top: 0;
  left: 0;
  font-weight: bolder;
  font-size: 16px;
  padding: 2px;
  transform: translate(10%, 10%);
  z-index: 1;
}

.status-alias {
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--primary);
  color: white;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 0 0 4px 0; /* 右下角圆角 */
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
  z-index: 1;

}

.apply-status {
  position: absolute;
  top: 25px;
  left: 0;
  background-color: var(--warning);
  color: white;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: bold;
  border-radius: 0 0 4px 0; /* 右下角圆角 */
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* 方法3：完整的圆圈+叉号图标 */
.circle-delete {
  width: 32px;
  height: 32px;
  position: absolute;
  cursor: pointer;
  border-radius: 50%;
  background: #ff4757;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(255, 71, 87, 0.4);
  transition: all 0.3s ease;
  right: 0;
  top: 0;
  transform: translate(-20%, 10%);
}

.circle-delete:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 8px rgba(255, 71, 87, 0.6);
}

.circle-delete::before,
.circle-delete::after {
  content: '';
  position: absolute;
  width: 16px;
  height: 2px;
  background: white;
  border-radius: 1px;
}

.circle-delete::before {
  transform: rotate(45deg);
}

.circle-delete::after {
  transform: rotate(-45deg);
}

/* end 完整的圆圈+叉号图标 */


.base-info {
  content: "基本信息";
  writing-mode: vertical-lr;
  text-orientation: mixed; /* 混合（英文单词不旋转） */
  /* 或 */
  text-orientation: upright; /* 所有文字直立 */
  background-color: var(--primary);
  color: #F2F2F2;
  padding: 20px 5px;
}

.price-info::before {
  content: "报价信息";
  writing-mode: vertical-lr;
  text-orientation: mixed; /* 混合（英文单词不旋转） */
  /* 或 */
  text-orientation: upright; /* 所有文字直立 */
  background-color: var(--primary);
  color: #F2F2F2;
  padding: 20px 5px;
}

.vertical-lr {
  writing-mode: vertical-lr;
  text-orientation: mixed; /* 混合（英文单词不旋转） */
  /* 或 */
  text-orientation: upright; /* 所有文字直立 */
}

.vertical-text {
  writing-mode: vertical-rl; /* 从右向左竖排（传统中文） */
  /* 或者 */
  writing-mode: vertical-lr; /* 从左向右竖排 */
}
</style>
